import { useState } from 'react';
import { NSModal } from 'bricks';
import { IOptionAnyValue } from 'bricks/types';
import useToast from 'hooks/useToast';
import { useUpdateProFormaSubprojectLink } from 'queries/ProForma/useUpdateProFormaSubprojectLink';
import ProjectLinkSelect from './ProjectLinkSelect/ProjectLinkSelect';
import { LINK_PROJECT_BUTTON_TEXT, LINK_TO_PROJECT_MODAL_HEADER } from './constants';

export interface ILinkToProjectModalProps {
    isOpen: boolean;
    toggle: () => void;
    dealId: number;
    proFormaId: number;
    proFormaCorrelationId?: string | null;
    assetTypeCorrelationId?: string | null;
    assetTypeName: string;
    onLinked?: (subprojectId: string) => void;
}

const LinkToProjectModal = ({
    isOpen,
    toggle,
    dealId,
    proFormaId,
    proFormaCorrelationId,
    assetTypeCorrelationId,
    assetTypeName,
    onLinked,
}: ILinkToProjectModalProps) => {
    const [selectedProject, setSelectedProject] = useState<IOptionAnyValue | undefined>();
    const [isLinking, setIsLinking] = useState(false);
    const { showSuccess } = useToast();
    const { mutate: updateSubprojectLink } = useUpdateProFormaSubprojectLink();

    const handleLinkProject = () => {
        if (isLinking || !selectedProject) return;
        setIsLinking(true);
        updateSubprojectLink({ dealId, proFormaId, subprojectUuid: selectedProject.value }, {
            onSuccess: () => {
                showSuccess('Project linked successfully');
                onLinked?.(selectedProject.value);
                toggle();
            },
            onSettled: () => setIsLinking(false),
        });
    };

    return (
        <NSModal
            isOpen={isOpen}
            toggle={toggle}
            modalHeaderText={LINK_TO_PROJECT_MODAL_HEADER}
            modalHeaderClassName="bg-primary text-white"
            modalFooterButtonText={LINK_PROJECT_BUTTON_TEXT}
            modalFooterButtonFunction={handleLinkProject}
            modalFooterIsButtonFunctionDisabled={!selectedProject || isLinking}
            modalFooterButtonIsLoading={isLinking}
            modalFooterCancelButtonText="Cancel"
        >
            <ProjectLinkSelect
                assetTypeCorrelationId={assetTypeCorrelationId}
                assetTypeName={assetTypeName}
                proFormaCorrelationId={proFormaCorrelationId}
                selectedOption={selectedProject}
                onSelectOption={setSelectedProject}
            />
        </NSModal>
    );
};

export default LinkToProjectModal;
